module.exports = __webpack_public_path__ + "static/media/Reporte_althar.1b50fda8.pdf";